import PlaceModal from './PlaceModal';

export default PlaceModal;
